import { API } from 'api';
import { PermissionsData, PermissionsParams } from './usePermissions.types';

export const fetchPermissions = async (
  params: PermissionsParams,
): Promise<PermissionsData> => {
  const response = await API.get<PermissionsData>(
    'users/frontend_permissions/',
    {
      params: params.geoEventId
        ? { geoEventId: params.geoEventId }
        : { lat: params.lat, lng: params.lng },
    },
  );

  return response.data;
};
